export function trySetTimeout(func, delay) {
    try {
        return setTimeout(func, delay)
    } catch (error) {
        console.warn("Failed to setTimeout", JSON.stringify(error))
        func()
        return null
    }
}